export default "__VITE_ASSET__BeSwfrML__"